module.exports = __webpack_public_path__ + "img/indexBigScreen.d922f295.jpg";